import { ApolloClient, gql } from 'apollo-boost';

const query = gql`
  mutation newRatingMutation(
    $reportId: String!
    $description: String!
    $rating: Int!
  ) {
    newRating(reportId: $reportId, description: $description, rating: $rating) {
      success
      id
    }
  }
`;

export const saveReportRating = (
  client: ApolloClient<object>,
  variables: {
    reportId: number | string;
    description?: string;
    rating: number | undefined;
  },
) => {
  return client.mutate({
    mutation: query,
    variables,
    fetchPolicy: 'no-cache',
  });
};
